export const feedbackCharCount = 100;
